<template >
  <div class="infoDetail" >
    <mt-header  style="background-color:#26a2ff;color: white"  fixed title="后勤动态" >
      <router-link to="/" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <div class="detail" v-if="tieZiObj && tieZiObj.data">
      <div  class="content2"   >
        <div class="content-item" >
          <div class="baseInfo" >
            <div class="title">
              <span class="title" style="font-weight: bold;font-size: 15px">{{tieZiObj.data.title}}</span>
            </div>
            <!-- <div class="infoContent"  v-html="tieZiObj.data.content" >-->
            <div class="infoContent"  v-html="tieZiObj.data.content">
             {{tieZiObj.data.content}}
            </div>
            <div style="float: right" >
              <div class="updateTime"  v-if=" tieZiObj.data.updateTime != null" >
                <span class="time">更新时间:{{tieZiObj.data.updateTime|formatDate}}</span>
              </div>

              <div class="browseCount" >
                <span class="time">浏览次数:{{tieZiObj.data.browseCount}}</span>
              </div>

              <div class="categoryName"  >
                <span class="time"> 发布栏目:{{tieZiObj.data.categoryName}}</span>
              </div>
              <div class="categoryName"  v-if=" tieZiObj.data.editor != null">
                <span class="time"> 编辑人:{{tieZiObj.data.editor}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import wxApi from '../assets/js/wxshare'
  import { getInfoById,OK,HOST} from '../api/data.js'
  import { Toast,MessageBox} from 'mint-ui';
  import moment from 'moment'
  import preview from 'vue-photo-preview'
  import 'vue-photo-preview/dist/skin.css'
  import Vue from 'vue'
  Vue.use(preview)
  export default {
    data() {
      return {
        infoDetail:[],//动态详情
        title:'',//动态标题
        imgUrl: '', // 分享图标
        desc: '点击可查看详细', //分享描述
        //link:location.href, //获取当前页面地址
        infoId:this.$route.query.infoId,//动态id
      }

    },
    filters: {
      formatDate: function (value) {
        return moment(value).format('YYYY-MM-DD HH:mm')
      },
      formatTime: function (value) {
        return moment(value).format('MM-DD HH:mm')
      },
      hideMiddle(val) {
        if(val!==null){
          return `${val.substring(0,1)}**`
        }
      }

    },
    computed: {
      tieZiObj: {
        get: function(){
          return this.infoDetail; // 在这里把临时对象的值通过计算属性赋值给页面中用到的对象
        },

      },
    },
    directives:{
      focus: {
        update: function (el,{value}) {
          let input=el.querySelector('input');
          if(value){
            input.focus();
          }
        }
      }
    },
    mounted() {
      setTimeout(()=>{
        this.getInfoDetail(this.infoId);

      },50)
    },
    methods: {
      getInfoDetail(value){
        getInfoById(value).then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){
              this.infoDetail=[];
              this.$store.dispatch('setSelected',"3")//确保返回的组件是加载动态
              if(res.data.data.image!=null && res.data.data.image!=""){
                this.imgUrl  =HOST +res.data.data.image.split(',')[0];
              }
              this.title =  res.data.data.title;
              var str  = res.data.data.content.replace(/<a [^>]*href=['"]([^'"]+)[^>]*>/gi, function (match,capture) {
                var newStr='<a  href="'+HOST+capture +'" download=""  />';
                return newStr;
              })
               str  = str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match,capture) {
                var newStr='<img src="'+HOST+capture +'" height="220" width="220"  />';
                return newStr;
              });
              str  = str.replace(/<embed [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match,capture) {
                var newStr='<video src="'+HOST+capture +'" height="220" width:100% controls="controls"  ></video>';
                return newStr;
              });
              res.data.data.content = str
              //图片加链接（点击实现查看原图）
              str =  res.data.data.content.replace(/(<img[^>]*?src=['""]([^'""]*?)['""][^>]*?>)/g, '<a href="$2">$1</a>');
              res.data.data.content = str
              this.infoDetail=res.data
              //修改在微信中默认分享
              wxApi.wxShowMenu(this.imgUrl,this.desc,this.title)
            }else{
              Toast('获取动态失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })
      }
    }

  }
</script>

<style lang="scss" scoped>
  .infoDetail{
    width:100%;
    margin-top:40px;

  }
  .detail{
    margin-bottom:48px;
    .content2{
      font-size:0.8rem;
      color:gray;
      .content-item{
        border-bottom:1px solid lightgray;
        padding:0.8rem 0.5rem;
        .baseInfo{
          padding:1px 0;
          overflow:hidden;
          .title{
            color:black;
            padding-bottom: 10px;

          }

        }
        .center{
          padding:0.5rem;
          text-align:left;

        }


      }
    }

  }

  img {
    //transform: scale(1);          /*图片原始大小1倍*/
    transition: all ease 0.5s; }  /*图片放大所用时间*/


  img.active {
    transform: scale(1);          /*点击图片实现显示原图*/
    position: absolute;           /*是相对于前面的容器定位的，此处要放大的图片，不能使用position：relative；以及float，否则会导致z-index无效*/
    z-index: 100; }


</style>



// WEBPACK FOOTER //
// src/components/infoDetail.vue